import Input from "@/components/input";
import { useTimelinePlayback } from "@/contexts/playback-context";
import { useSelector } from "@legendapp/state/react";

const DEFAULT_SEEK_AMOUNT = "1.000";

export function SeekAmountInput() {
  const timelinePlayback = useTimelinePlayback();
  const seekAmount = useSelector(() => timelinePlayback.seekAmount.get());

  const handleSeekAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (!/^\d*\.?\d*$/.test(value)) {
      return;
    }

    if (value.startsWith("0") && !value.startsWith("0.") && value.length > 1) {
      return;
    }

    if (value.includes(".") && value.split(".")[1].length > 3) {
      return;
    }

    if (value === "" || (!isNaN(parseFloat(value)) && parseFloat(value) >= 0)) {
      timelinePlayback.seekAmount.set(value);
    }
  };

  return (
    <Input
      type="text"
      name="seekAmount"
      label="Seek Amount(sec)"
      className="h-10 w-36"
      value={seekAmount}
      floatingLabel={false}
      placeholder="0.005"
      onChange={handleSeekAmountChange}
      onBlur={(e) => {
        const value = e.target.value;
        if (!value) {
          timelinePlayback.seekAmount.set(DEFAULT_SEEK_AMOUNT);
          return;
        }

        const numValue = parseFloat(value);
        if (isNaN(numValue) || numValue === 0) {
          timelinePlayback.seekAmount.set(DEFAULT_SEEK_AMOUNT);
          return;
        }

        const formattedValue = numValue.toFixed(3);
        timelinePlayback.seekAmount.set(formattedValue);
      }}
    />
  );
}
